import { useContext, useEffect, useState } from "react";
import SeleccionContext from "../../../context/Seleccion/SeleccionContext";
import { PDFViewer, Document } from "@react-pdf/renderer";
import PortadaPsicolaboral from "./components/PortadaPsicolaboral";
import ConGraficoEjecutivo2 from "./components/ConGraficoEjecutivo2";
import { IPDFPsicolaboral } from "../../../interfaces/ISeleccion";
import RadarChart from "./components/RadarChart";

const ConGraficoEjecutivo = (props: IPDFPsicolaboral) => {
  const { busperid, formato, token } = props;
  const { listaReportePdfPsicolaboral, postReportePdfPsicolaboral } =
    useContext(SeleccionContext);
  const [formList, setFormList] = useState<any>({});
  const [loading, setLoading] = useState<boolean | undefined>(true);
  const [image64, setImage64] = useState<any>(undefined);
  const [errorLoading, setErrorLoading] = useState<boolean | undefined>(
    undefined
  );

  useEffect(() => {
    if (busperid && formato) {
      postReportePdfPsicolaboral({
        token,
        formato,
        busperid,
        setLoading,
        setErrorLoading,
      });
    }
  }, []);

  useEffect(() => {
    try {
      if (listaReportePdfPsicolaboral) {
        setFormList({ ...listaReportePdfPsicolaboral[busperid] });
      }
    } catch (error) {
      console.log(error);
    }
  }, [listaReportePdfPsicolaboral]);

  return (
    <>
      {!errorLoading ? (
        <>
          {!image64 ? (
            <>
              <div className="center-container">
                <div className="loading-container">
                  <div className="loading-text">Cargando PDF</div>
                  <div className="loading-dots">
                    <span className="dot dot1"></span>
                    <span className="dot dot2"></span>
                    <span className="dot dot3"></span>
                  </div>
                </div>
              </div>
              <RadarChart formList={formList} setImage64={setImage64} />
            </>
          ) : (
            <>
              {loading ? (
                <div className="center-container">
                  <div className="loading-container">
                    <div className="loading-text">Cargando PDF</div>
                    <div className="loading-dots">
                      <span className="dot dot1"></span>
                      <span className="dot dot2"></span>
                      <span className="dot dot3"></span>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", overflow: "hidden" }}>
                  <PDFViewer style={{ width: "100%", height: "100vh" }}>
                    <Document>
                      <PortadaPsicolaboral formList={formList} />
                      <ConGraficoEjecutivo2
                        formList={formList}
                        grafico={image64}
                      />
                    </Document>
                  </PDFViewer>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <div className="center-container">
            <div className="loading-container">
              <div className="loading-text">Error al cargar PDF</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ConGraficoEjecutivo;
